import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";

import Footer from "../components/footer/Footer";

function Toast({ message, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [onClose]);

  const isSuccess = type === "success";
  return (
    <div style={{
      position: "fixed", bottom: "100px", left: "50%", transform: "translateX(-50%)",
      zIndex: 99999, display: "flex", alignItems: "center", gap: "12px",
      background: "#1a1b2e", border: `1px solid ${isSuccess ? "#5c27fe" : "#ff6b6b"}`,
      borderRadius: "12px", padding: "14px 20px",
      boxShadow: `0 8px 32px rgba(0,0,0,0.4), 0 0 20px ${isSuccess ? "rgba(92,39,254,0.2)" : "rgba(255,107,107,0.2)"}`,
      animation: "toastIn 0.3s cubic-bezier(0.34,1.56,0.64,1)",
      minWidth: "280px", maxWidth: "90vw",
    }}>
      <span style={{
        width: "32px", height: "32px", borderRadius: "50%", flexShrink: 0,
        background: isSuccess ? "linear-gradient(264.28deg,#dec7ff -38.2%,#5c27fe 103.12%)" : "rgba(255,107,107,0.15)",
        display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px",
      }}>
        {isSuccess ? "✓" : "✕"}
      </span>
      <span style={{ color: "#fff", fontSize: "14px", fontWeight: 500, flex: 1 }}>{message}</span>
      <button onClick={onClose} style={{
        background: "none", border: "none", color: "rgba(255,255,255,0.4)",
        cursor: "pointer", fontSize: "18px", lineHeight: 1, padding: 0,
      }}>×</button>
      <style>{`@keyframes toastIn{from{opacity:0;transform:translateX(-50%) translateY(20px) scale(0.9)}to{opacity:1;transform:translateX(-50%) translateY(0) scale(1)}}`}</style>
    </div>
  );
}

const EMAILJS_SERVICE_ID = "service_e36oxin";
const EMAILJS_TEMPLATE_ID = "template_tudubkg";
const EMAILJS_PUBLIC_KEY = "WUyalDfLQHQrS1Omi";

function Contact() {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState({
    sending: false,
    success: null,
    error: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setStatus({
        sending: false,
        success: null,
        error: "Please fill in name, email and message.",
      });
      return;
    }
    setStatus({ sending: true, success: null, error: null });
    emailjs
      .sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        formRef.current,
        EMAILJS_PUBLIC_KEY,
      )
      .then(() => {
        setStatus({
          sending: false,
          success: "Message sent! I'll get back to you soon.",
          error: null,
        });
        setForm({ name: "", email: "", phone: "", subject: "", message: "" });
      })
      .catch(() => {
        setStatus({
          sending: false,
          success: null,
          error: "Something went wrong. Please try again.",
        });
      });
  };

  const dismissToast = () => setStatus((prev) => ({ ...prev, success: null, error: null }));

  return (
    <div className="wrapper">
      {status.success && <Toast message={status.success} type="success" onClose={dismissToast} />}
      {status.error && <Toast message={status.error} type="error" onClose={dismissToast} />}
      {/* <PageTitle title='Contact' /> */}

      <section className="touch">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>Get in Touch!</span>
                </h6>
                <h3 className="heading">
                  Let’s Start Working <br />
                  Together
                </h3>
              </div>
              <div className="touch__main">
                <div className="info">
                  <h5>Contact information</h5>
                  <ul className="list">
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7V7Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7V7Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <p>Tirunelveli, Tamilnadu</p>
                    </li>
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_794_6441)">
                          <path
                            d="M1.5 4.5C1.5 10.0227 5.97733 14.5 11.5 14.5H13C13.3978 14.5 13.7794 14.342 14.0607 14.0607C14.342 13.7794 14.5 13.3978 14.5 13V12.0853C14.5 11.7413 14.266 11.4413 13.932 11.358L10.9833 10.6207C10.69 10.5473 10.382 10.6573 10.2013 10.8987L9.55467 11.7607C9.36667 12.0113 9.042 12.122 8.748 12.014C7.65659 11.6128 6.66544 10.9791 5.84319 10.1568C5.02094 9.33456 4.38725 8.34341 3.986 7.252C3.878 6.958 3.98867 6.63333 4.23933 6.44533L5.10133 5.79867C5.34333 5.618 5.45267 5.30933 5.37933 5.01667L4.642 2.068C4.60143 1.9058 4.50781 1.7618 4.37604 1.65889C4.24426 1.55598 4.08187 1.50006 3.91467 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V4.5Z"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_794_6441">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <p>+91 63815 19592</p>
                    </li>
                    <li>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.5 4.5V11.5C14.5 11.8978 14.342 12.2794 14.0607 12.5607C13.7794 12.842 13.3978 13 13 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V4.5M14.5 4.5C14.5 4.10218 14.342 3.72064 14.0607 3.43934C13.7794 3.15804 13.3978 3 13 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5M14.5 4.5V4.662C14.5 4.9181 14.4345 5.16994 14.3096 5.39353C14.1848 5.61712 14.0047 5.80502 13.7867 5.93933L8.78667 9.016C8.55014 9.16169 8.2778 9.23883 8 9.23883C7.7222 9.23883 7.44986 9.16169 7.21333 9.016L2.21333 5.94C1.99528 5.80569 1.81525 5.61779 1.69038 5.3942C1.56551 5.1706 1.49997 4.91876 1.5 4.66267V4.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <p>imjacobrajan@gmail.com</p>
                    </li>
                  </ul>

                  {/* <div className="image">
                    <img src={img} alt="cyfonii" />
                  </div> */}
                </div>

                <form
                  ref={formRef}
                  className="form-box"
                  onSubmit={handleSubmit}
                >
                  <input
                    type="hidden"
                    name="time"
                    value={new Date().toLocaleString()}
                    readOnly
                  />
                  <div className="row">
                    <div className="col">
                      <label>Your name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={form.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col">
                      <label>Your email</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        value={form.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label>Your phone</label>
                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        value={form.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col">
                      <label>Subject</label>
                      <select
                        name="subject"
                        className="form-control"
                        value={form.subject}
                        onChange={handleChange}
                      >
                        <option value="">Select a subject</option>
                        <option value="Hire Me">Hire Me</option>
                        <option value="Freelance Project">
                          Freelance Project
                        </option>
                        <option value="Full-Time Opportunity">
                          Full-Time Opportunity
                        </option>
                        <option value="Collaboration">Collaboration</option>
                        <option value="Agency / Digital Marketing">
                          Agency / Digital Marketing
                        </option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label>Message</label>
                      <textarea
                        name="message"
                        cols="30"
                        rows="10"
                        value={form.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                  <div className="row mb-0">
                    <div className="col">
                      <button
                        type="submit"
                        className="action-btn"
                        disabled={status.sending}
                      >
                        <span>
                          {status.sending ? "Sending..." : "Send Now"}
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="map">
        <div className="container">
          <div className="row">
            <div className="map__main">
              <iframe
                src="https://maps.google.com/maps?q=Chennai,+Tamil+Nadu,+India&z=12&output=embed"
                title="map"
                height="600"
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              />
            </div>
          </div>
        </div>
      </div>

      {/* <Faq3 data={dataFaqs} /> */}

      <Footer />
    </div>
  );
}

export default Contact;
